<template>
<div class="talkWithGuide-Box">
    <slot />
</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
export default {
    computed: {
        ...mapState([])
    },
    methods: {
        ...mapActions([]),
    }
}
</script>

<style lang="css"></style>
